import { Component } from "react";
import classNames from "classnames";
import styles from "../../blocks/StandardTheme/styles/VideoBlock.module.scss";

interface IHtml5VideoProps {
  title?: string;
  embedLink: string;
}

export default class Html5Video extends Component<IHtml5VideoProps> {
  render() {
    const { embedLink } = this.props;
    const embedResponsiveItemClassName = classNames({
      [styles.embedResponsiveItem]: true,
    });
    return <video className={embedResponsiveItemClassName} src={embedLink} />;
  }
}
